"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _TooltipError = _interopRequireDefault(require("./TooltipError"));
var _Textarea = _interopRequireDefault(require("./Textarea.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Textarea = function Textarea(_ref) {
  var id = _ref.id,
    required = _ref.required,
    error = _ref.error,
    disabled = _ref.disabled,
    onBlur = _ref.onBlur,
    placeholder = _ref.placeholder,
    value = _ref.value,
    onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    maxLength = _ref.maxLength,
    dataTestId = _ref.dataTestId;
  var hasError = !(0, _utils.isBlank)(error);
  return /*#__PURE__*/_react["default"].createElement(_Textarea["default"], {
    disabled: disabled,
    placeholder: placeholder,
    onChange: onChange,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    value: value,
    hasError: hasError ? "".concat(hasError) : null,
    autoComplete: "off",
    "aria-label": ariaLabel || placeholder,
    maxLength: maxLength,
    "data-testid": dataTestId
  }, hasError && /*#__PURE__*/_react["default"].createElement(_TooltipError["default"], {
    error: error,
    id: "".concat(id, "Error")
  }), required && (0, _utils.isBlank)(value) && /*#__PURE__*/_react["default"].createElement(_TooltipError["default"], {
    error: "This is a mandatory field",
    id: "".concat(id, "RequiredError")
  }), children);
};
Textarea.propTypes = {
  id: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onBlur: _propTypes["default"].func,
  onChange: _propTypes["default"].func.isRequired,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].string,
  onKeyDown: _propTypes["default"].func,
  ariaLabel: _propTypes["default"].string,
  error: _propTypes["default"].string,
  children: _propTypes["default"].element,
  maxLength: _propTypes["default"].number,
  dataTestId: _propTypes["default"].string
};
Textarea.defaultProps = {
  id: '',
  required: false,
  disabled: false,
  onBlur: undefined,
  onKeyDown: undefined,
  placeholder: '',
  value: '',
  ariaLabel: '',
  error: '',
  children: null,
  maxLength: 1000,
  dataTestId: 'text-area'
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Textarea);